<template>
    <div class="invites">

        <div v-show="showDismissibleAlert" class="alert alert-info" @dismissed="alertMessage = null" role="alert" aria-live="polite">
            {{alertMessage}}
        </div>

        <table class="table table-striped">
            <thead>
                <tr>
                    <th v-for="field in inviteFields">{{ field.label }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in invites">
                    <td>{{ item.to_name }}</td>
                    <td>{{ item.to_email }}</td>
                    <td>
                        {{ formatDate(item.effective_invite_date)}}
                    </td>
                    <td>
                        {{ formatDate(item.accepted_at) }}
                    </td>
                    <td>
                        <button type="button" v-if="!item.registered" :disabled="!registrationCode.is_valid" @click="resendInvite(item)" class="btn btn-sm btn-primary mr-1">
                            Resend Invite
                        </button>
                    </td> 
                </tr>
            </tbody>
        </table>

        <div class="container">
            <div v-if="invites.length < 1" class="row mt-2 ml-3">
                <div class="col-lg">{{ emptyMessage }}</div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col text-left">
                <button type="button" class="btn btn-orange-blue" :disabled="!registrationCode.is_valid" @click="showCreateInviteModal">New Invite</button>
                <div v-show="!registrationCode.is_valid" class="text-center alert alert-danger my-2">{{ codeIsInvalidText }}</div>
            </div>
        </div>
    </div>
</template>

<style>
.alert-dismissible {
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: bold;
}
.alert-dismissible .close {
    padding-top: 9px !important;
    font-size: 30px !important;
    font-weight: bold !important;
}
</style>

<script>
    import moment from 'moment';
    import { mapWritableState } from 'pinia'
    import { useRegistrationCodesStore } from './store.js';

    export default {
        props: {
            'registration-code': {
                type: Object,
                required: false,
                default: {}
            }, 
            'refresh-invites': {
                required: true
            }
        },
        data() {
            return {
                testModal: false,
                invites: [],
                loading: false,
                inviteFields: [
                    { 
                        key: 'to_name', 
                        label: 'Name', 
                        sortable: true, 
                        thStyle: {
                            width: '20%'
                        }
                    },
                    { 
                        key: 'to_email', 
                        label: 'Email', 
                        sortable: true
                    },
                    { 
                        key: 'invited_at', 
                        label: 'Invited', 
                        sortable: true, 
                        class: 'invited-date' 
                    },
                    { 
                        key: 'accepted_at', 
                        label: 'Registered', 
                        sortable: true, 
                        class: 'registered-date' 
                    },
                    { 
                        key: 'actions', 
                        label: 'Actions', 
                        class: 'resend-button' 
                    },
                ],
                invitesModal: false,
                alertMessage: null,
                invite: {},
                createInviteModal: false,
                previewInviteModal: false,
                recipient_options: [
                    { text: 'Program User', value: 'program-user' },
                    { text: 'TA Consultant', value: 'ta-consultant' },
                    { text: 'Partner User', value: 'partner-user' }
                ],
                filter: null,
                showDismissibleAlert: false
            }
        },
        watch: {
            registrationCode(to, from) {
                if (to === null) {
                    this.invites = [];
                } else if (to.code) {
                    this.getInvites();
                }
            },
            refreshInvites: function() {
                this.getInvites();
            }
        },
        computed: {
            emptyMessage: function() {
                return (this.loading) ? 'Loading...' : 'No invites exist for this code';
            },
            codeIsInvalidText: function() {
                if(this.registrationCode) {
                    if(!this.registrationCode.is_valid) {
                        if(!this.registrationCode.enabled) {
                            return "This registration code has been disabled.";
                        }
                        return "The partner associated with this registration code is inactive.";
                    }
                    return "Registration code is valid.";
                }
                return "No registration code has been selected";
            },
            ...mapWritableState(useRegistrationCodesStore, [
                'bodyComponent',
                'title',
            ]),
        },
        methods: {
            getInvites() {
                var config = {  headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache'}};
                this.loading = true;
                if (this.registrationCode.code !== undefined) {
                    axios.get('/api/invites?code='+ this.registrationCode.code, config)
                    .then((response) => {
                        this.invites = response.data.data
                        this.loading = false;
                    })
                    .catch((error) => {
                        console.error(error)
                        this.loading = false;
                    })
                }
            },
            openCreateInvite() {
                this.$emit(
                    'openCreateInvite', 
                    { 
                        registrationCode: this.registrationCode 
                    }
                );
            },
            resendInvite(item) {
                this.showDismissibleAlert = false
                item.last_resent_at = moment().format('YYYY-MM-DD hh:mm:ss');
                axios.put('/api/invites/'+item.id, item)
                .then(response => {
                    this.alertMessage = 'Invite resent successfully';
                    this.showDismissibleAlert = true;
                    this.getInvites();
                })
                .catch(error => {
                    console.error(error)
                })
            },
            showCreateInviteModal() {
                this.bodyComponent = 'CreateInviteForm';
                this.title = "New Invite";
            },
            formatDate(dateString, format = 'MM/DD/YY') {
                if (moment(dateString).isValid()) {
                    return moment(dateString).utc().format(format)
                }
                return null
            },
        },
        mounted() {
            this.getInvites();
        }
    }
</script>
